import { useEffect, useState } from 'react';

import { SILENCE_WARNING_COOL_DOWN } from '@/entities/session';
import { metronome } from '@/shared/lib/metronome';

type UseSilenceWarningReturn = {
    isWarningShown: boolean;
    hideWarning: () => void;
};

export function useSilenceWarning(isSilent: boolean): UseSilenceWarningReturn {
    const [isWarningHidden, setIsWarningHidden] = useState(false);

    useEffect(() => {
        if (!isWarningHidden) {
            return;
        }

        return metronome(() => setIsWarningHidden(false), SILENCE_WARNING_COOL_DOWN, {
            tickOnce: true,
        });
    }, [isWarningHidden, setIsWarningHidden]);

    const hideWarning = () => setIsWarningHidden(true);

    return {
        isWarningShown: isSilent && !isWarningHidden,
        hideWarning,
    };
}
